<header fxLayout fxLayoutAlign="start end">
  <h1 fxFlex>{{ title }}</h1>
  <div fxFlex="nogrow" class="date" *ngIf="updated">Last updated: {{ updated | date:'longDate'}}</div>
  <div fxFlex="nogrow" class="login" *ngIf="login && !authorized" (click)="onLogin()">
    <mat-icon>account_circle</mat-icon>
    <span>Employee login</span>
  </div>
</header>
